import { render, staticRenderFns } from "./FieldsPanel.vue?vue&type=template&id=36a9991d&scoped=true"
import script from "./FieldsPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./FieldsPanel.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FieldsPanel.vue?vue&type=style&index=0&id=36a9991d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a9991d",
  null
  
)

export default component.exports